import React, { Component } from 'react';
// import { DndProvider } from 'react-dnd'
// import HTML5Backend from 'react-dnd-html5-backend'
import { pushToast } from '../../../../../stateManager/store/toast/actions'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Spin, Icon } from 'antd';
import * as _ from 'lodash';
import ThemeSwitcher from 'react-css-vars'


import SplitPane, { Pane } from '../../../../../plugin/react-split-pane';
import style from './create.module.sass';
import Components from './Components';
import { formPreview, formSave, HeaderData, makeFormDupliacte, ThemeReload, ResourceLock, fAssetEdit, fCardSelect } from '../../../../../helpers/RxServices';
import Properties from './properties';
import { store } from '../../../../../stateManager';
import { Http } from '../../../../../helpers/axois';
import { addForms, addThemeInfo, autoCompleteVariables, saveOriginalFormData, selectedForm,removeForm, addTabs } from '../../../../../stateManager/store/formCreation/action';
import { addWidget, addPackage, clearProduct } from '../../../../../stateManager/store/product/actions';
import { loadAssets } from '../../../../../stateManager/store/assets/action';
import { editAsset } from '../../../../../stateManager/store/assets/action';
import { loadPlugins } from "../../../../../helpers/MicroFrontend"
import { generatePluginSchema, encodeBase64, decodeBase64, deserializeAssets, getInstalledPlugins, useToast, getCardContainer } from "../../../../../helpers/commonFunction"
import { GCPENDPOINT, MARKETPLACE_CORE } from '../../../../../constant/common'
import FormsTabs from './Tabs';
import { AppState } from '../../../../../stateManager/store';
import { logger } from '../../../../../constant/winston';
import { redirectOnError, attachCoreTypeDefs, attachTypeDefs, mergeAssetsWithForm } from "../../../../../helpers/commonFunction"
import { initializeA8FormsTypeDefs } from "../../../../../helpers/typedefinitions/a8forms"
import AssetTab from './Tabs/AssetTab';
import { fAssetEditType } from '../../../../../helpers/RxServiceTypes';
import { resetWidgetIds} from '../../../../../stateManager/store/widgetsID/actions';
import {updateFormVersion} from '../../../../../stateManager/store/apps/actions';

declare const window: any;

const defaultTheme = {
    formPrimaryColor: '#fa7412',
    formPrimaryColorShadow: '#fa741222',
    formFontColor: '#000000',
    formBorderColor: '#0000004D',
    formBorderRadius: '8px',
    formFontSize: '12px',
    formHeaderSize: '14px',
    formSpacing: '0px'
}

interface State {
    loading: boolean,
    theme: any
    selectedFormData: any[]
    widgetsLoading: boolean,
    assetsLoading: boolean,
    resourceLock: any
}

class FormCreate extends Component<any, State> {
    formPreview: any;
    formSave: any;
    formFetch: any;
    HeaderData: any
    makeFormDupliacte: any;
    ThemeReload: any;

    state = {
        loading: true,
        theme: defaultTheme,
        selectedFormData: [],
        widgetsLoading: true,
        assetsLoading: true,
        resourceLock: {
            userId: ''
        }
    }

    computeFontSize(size: any) {
        const initialValue = 8
        const stepValue = 0.5
        const stepsToAdd = (size === 0) ? 0 : (size / 10)
        return `${initialValue + (stepsToAdd * stepValue)}px`
    }

    computeHeaderSize(size: any) {
        const initialValue = 12
        const stepValue = 1
        const stepsToAdd = size
        return `${initialValue + (stepsToAdd * stepValue)}px`
    }

    computeSpacing(size: any) {
        if (size === 'Smaller')
            return '0px'
        else if (size === 'Normal')
            return '4px'
        else
            return '16px'
    }

    componentDidMount() {       
        this.formPreview = formPreview.getMessage().subscribe((res: any) => {
            if (res && res.from) {
                const { appId, formId } = this.props.match.params;
                window.open(`#/apps/list/${appId}/forms/list/${formId}/preview`)
            }
        })
        this.formSave = formSave.getMessage().subscribe((res: any) => {
        const widgetIDs = this.props.widgetId
        const selectedOrgId = this.props.selectedOrgId
            if (res && res.from) {
                const isCommit = (res.from === 'commit')
                const { appId, formId } = this.props.match.params;
                let formData = store.getState().formcreation[formId];
                let importedAssets:any = {}
                if (formData[0]?.formProperties?.importedAssets && this.props.assetsList){
                    Object.keys(this.props.assetsList).filter((assetId)=>{
                        if (formData[0]?.formProperties?.importedAssets.includes(assetId)){
                            importedAssets[assetId] = this.props.assetsList[assetId]
                        }
                    })
                }
                // let { appVersion } = this.props
                const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
                // embed the assets in the form properties seleted assets
                formData[0].assets = importedAssets;

                const removeChildren = (field: any) => {
                    if(field.type === 'TabBar' || field.type === 'Section' || field.type === 'Container') {
                        delete field.children
                        field.fields.forEach((field: any) => {
                            removeChildren(field)
                        })
                        return
                    }

                    delete field.fields
                    delete field.children

                    if(field?.data?.preload?.fun?.comSource) {
                        delete field.data.preload.fun.comSource
                    }
                }

                formData.forEach((tab: any) => removeChildren(tab))

                formData = formData && formData.filter((item:any,i:number)=>{
                    if (i === 0) {
                        return {...item}
                    } else if (item["assets"]) {
                        delete item["assets"]
                        delete item["theme"]
                        return {...item}
                    } else {
                        return {...item}
                    }
                })
                mergeAssetsWithForm(formData, this.props.assetsList)
                const data = {
                    source: encodeBase64(JSON.stringify(formData)),
                    appId: appId,
                    version: this.props.appVersion && this.props.appVersion.versionId,
                    branchId: currentBranchId
                }
                const unimporData = {
                    appId: appId,
                    formId: formId
                }
                Promise.all(widgetIDs.datas.map((id: string) => {
                    const endpoint = `orgs/${selectedOrgId}/store/products/${id}/import`;
                    return Http.put(endpoint, unimporData).toPromise().catch((error) => {
                        this.props.pushToast && this.props.pushToast(
                            { type: 'error', message: 'Not Authorized: Error in unimporting widgets' }
                        )
                      });
                })).then(() => {

                    // check that packages or wigets are using in forms
                    const getProductId = formData.flatMap((separatedTab: any) =>
                        separatedTab.fields.flatMap((tabFields: any) =>
                            tabFields.fields.map((fields: any) =>
                                fields.productId ? fields.productId : null
                            ).filter((id: any) => id !== null)
                        )
                    );
                    const formUpdation = getProductId.length === 0 ? [] : getProductId;
                    const formUpdationId = formUpdation.filter((item: any, index: any) => formUpdation.indexOf(item) === index)

                    // get call to known that widgets or packages are imported or not
                    const checkimportedProduct = `/apps/${appId}/forms/${formId}/store/products`;
                    Http.get(checkimportedProduct).subscribe((response: any) => {
                        let products = response;
                        if (Array.isArray(products.products)) {
                            const productIDs = products.products.map((products: any) => {
                                return products.store_product_id;
                            });
                            const resultCall = formUpdationId.filter((_val: any) => !productIDs.includes(formUpdationId))
                            // If a widget is used in forms but not imported, then use the API to import it again.
                            if (resultCall) {
                                resultCall.map((widgetId: any) => {
                                    const endpoint = `orgs/${selectedOrgId}/store/products/${widgetId}/import`;
                                    Http.post(endpoint, { appId, formId }).toPromise();
                                })
                            }
                        }
                    },(err) => {
                        if(err==="Forbidden"){
                            this.props.pushToast && this.props.pushToast(
                                { type: 'error', message: 'Not Authorized: Error fetching widgets' }
                            )
                        }
                    })
                })
                // after api call clear unimport Marketplace app state 
                this.props.resetWidgetIds();
                Http.put(`/forms/${formId}?isCommit=${isCommit}${res.discard ? '&discard=true':''}`, data).subscribe((formRes) => {
                    isCommit && this.addFormData(undefined, undefined, undefined, res.discard)
                    this.props.saveOriginalFormData(JSON.stringify(formData))
                    this.props.pushToast && this.props.pushToast(
                        { type: 'success', message: `Form ${isCommit ? 'committed' : 'saved'} successfully` }
                    )
                }, (err) => {
                    this.props.pushToast && this.props.pushToast(
                        { type: 'error', message: (err && err.message) ? err.message : `Form ${isCommit ? 'commit' : 'save'} failed` }
                    )
                })
            }
        })
        this.makeFormDupliacte = makeFormDupliacte.getMessage().subscribe((res: any) => {
            if (res && res.from === "duplicate") {
                const { appId, formId } = this.props.match.params;
                const formData = store.getState().formcreation[formId];
                let { appVersion } = this.props
                const data = {
                    source: encodeBase64(JSON.stringify(formData)),
                    appId: appId,
                    version: appVersion && appVersion.versionId,
                    branchId: res.branchId
                }
                Http.put(`/forms/${formId}`, data).subscribe((_formRes) => {
                    Http.get(`/duplicateForm/${formId}?appId=${appId}&versionId=${appVersion && appVersion.versionId}&formName=${res.formName}&themeId=${res.theme}&branchId=${res.branchId}&displayName=${res.displayName}`).subscribe((formRes) => {
                        this.props.pushToast && this.props.pushToast(
                            { type: 'success', message: 'Form saved and duplicated successfully' }
                        )
                    }, (err: any) => {
                        logger.error("formResformResformRes error", err);
                        this.props.pushToast && this.props.pushToast(
                            { type: 'error', message: (err && err.message) ? err.message : 'Form duplication failed' }
                        )
                    })




                }, (err) => {
                    this.props.pushToast && this.props.pushToast(
                        { type: 'error', message: (err && err.message) ? err.message : "Form updation failed" }
                    )
                })
            }

        })
        this.ThemeReload = ThemeReload.getMessage().subscribe(() => {
            this.addFormData()
        })
        this.formFetch = ResourceLock.getMessage().subscribe(({ message, callback }) => {
            if (message === 'FORM_REFETCH') {
                this.addFormData('', true, callback)
            } else if (message === 'FORM_REFETCH_LOCK') {
                callback ? this.refetchLockStatus(callback) : this.refetchLockStatus()
            }
        })
        // load marketplace core package
        loadPlugins(MARKETPLACE_CORE, "marketplaceCore", () => {
            initializeA8FormsTypeDefs()
            attachCoreTypeDefs();
            this.loadImportedWidgets().catch(() => this.setState({ widgetsLoading: false }))
            this.fetchAssets().catch(() => this.setState({ assetsLoading: false }))
            this.addFormData()
        })
        fAssetEdit.getMessage().subscribe((res: fAssetEditType) => {
            if (res.id) {
                this.props.editAsset(res.id)
            }
        })
    }
    componentWillUnmount() {
        if (this.formPreview) this.formPreview.unsubscribe();
        if (this.formSave) this.formSave.unsubscribe();
        if (this.HeaderData) this.HeaderData.unsubscribe()
        if (this.makeFormDupliacte) this.makeFormDupliacte.unsubscribe()
        if (this.formFetch) this.formFetch.unsubscribe()
        this.props.removeForm({id :  this.props.match.params.formId})
    }

    componentWillReceiveProps(props: any) {
        const newFormId = props.match.params.formId;
        const formId = this.props.match.params.formId
        if (formId !== newFormId) {
            this.addFormData(newFormId);
        }
    }

    async fetchAssets() {
        try {
            
            if((!this.props.orgPermissions?.includes("app.View") || !this.props.orgPermissions?.includes("forms.View")) &&  this.props.loggedInUser?.id!=this.props.selectedOrganisation?.owner){
                this.props.pushToast && this.props.pushToast(
                    { type: 'error', message: 'Not Authorized: Error fetching assets' }
                )
                return
            }
            // get the assets
            const orgId = this.props.selectedOrg;
            const res: any = await Http.get(`/orgs/${orgId}/assets`).toPromise();

            // deserialize assets and update the store
            const assets = deserializeAssets(res.data)
            this.props.loadAssets(assets)

            // get the marketplace plugins that are present in
            // the assets
            const mapAssetsToForm: any = [{ fields: [] }]
            Object.keys(assets).forEach(el => {
                if (assets[el].json) {
                    mapAssetsToForm[0].fields.push(assets[el].json)
                }
            })
            const plugins = getInstalledPlugins(mapAssetsToForm, [])

            // load the marketplace plugins present in the assets
            // to the DOM
            this.loadAssetPlugins(plugins)
        } catch (err) {
            if (err === "Forbidden") {
                this.props.pushToast && this.props.pushToast(
                    { type: 'error', message: 'Not Authorized: Error fetching assets' }
                )
            }
            throw new Error(`failed to fetch assets: ${err}`)
        }
    }

    async loadImportedWidgets() {
        try{
            if((!this.props.orgPermissions?.includes("marketplace.PublishWidget") || !this.props.orgPermissions?.includes("app.View")) &&  this.props.loggedInUserId!=this.props.selectedOrganisation?.owner){
                this.setState({ widgetsLoading: false })
                this.props.pushToast && this.props.pushToast(
                    { type: 'error',  message: 'Not Authorized: Error loading imported widgets' }
                )
                return
            }
        const formId = this.props.match.params.formId;
        const appId = this.props.match.params.appId;
        const endpoint = `apps/${appId}/forms/${formId}/store/products`
        const res: any = await Http.get(endpoint).toPromise();

        if (res.products && res.products.length) {
            this.props.clearProduct(formId)
            const products = res.products.map((el: any) => ({ ...el, id: el.store_product_id }))
            await Promise.all(products.map((el: any, index: number) => this.importWidget(el, index, res.products.length)))
        } else {
            this.setState({ widgetsLoading: false })
            }
        } catch (err) {
            this.setState({ widgetsLoading: false })
            if (err === "Forbidden") {
                this.props.pushToast && this.props.pushToast(
                    { type: 'error', message: 'Not Authorized: Error loading imported widgets' }
                )
            }
    }
    }

    async importWidget(widget: any, widgetIdx: number, productsLen: number) {
        const formId = this.props.match.params.formId;
        const pluginUrl =  widget.object_url?.startsWith("https://") ? widget.object_url : GCPENDPOINT + widget.object_url;

        await loadPlugins(pluginUrl, widget.id, async () => {
            const { type: pluginType, data: plugin } = window[widget.build_id]

            // attach typedefinitions coming from the plugins
            attachTypeDefs(widget.build_id)

            if (pluginType === "Package") {
                const packageWidgets = Object.keys(plugin.widgets).map((el: any) => {
                    const packageWidget = plugin.widgets[el]
                    return generatePluginSchema(
                        el,
                        packageWidget.name,
                        widget.build_id,
                        pluginUrl,
                        { widgetName: el, productId: widget.id }
                    )
                })
                this.props.addPackage({
                    formId,
                    pkg: {
                        [widget.name]: packageWidgets
                    }
                })
            } else {
                const newWidget = generatePluginSchema(
                    widget.build_id,
                    widget.name,
                    widget.build_id,
                    pluginUrl,
                    { productId: widget.id }
                )
                this.props.addWidget({
                    formId,
                    widget: newWidget,
                })
            }

            // when all the widgets are loaded
            if (widgetIdx === productsLen - 1) {
                this.setState({ widgetsLoading: false })
            }
        });
    }

    async loadAssetPlugins(plugins: any[]) {
        if (!plugins.length) {
            this.setState({ assetsLoading: false });
        }

        await Promise.all(
            plugins.map((plugin, idx) =>
                loadPlugins(plugin.url, plugin.name, () => {
                    attachTypeDefs(plugin.name)
                    if (plugins.length - 1 === idx) {
                        this.setState({ assetsLoading: false });
                    }
                })
            )
        );
    }

    refetchLockStatus(callback?: any) {
        const formId = this.props.match.params.formId;
        const appId = this.props.match.params.appId;
        const version = this.props.appVersion && this.props.appVersion.versionId;
        const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
        Http.get(`/apps/${appId}/forms/${formId}?versionId=${version}&branchId=${currentBranchId}`).subscribe((res: any) => {
            if (res.length > 0) {
                const data = res[0]
                this.setState({
                    resourceLock: data.resourceLock || {}
                })
                // send resource lock data to header
                ResourceLock.sendMessage({
                    message: 'FORM_REFETCHED',
                    resourceLock: data.resourceLock || {},
                    refetchedCallback: () => callback && callback(data.resourceLock)
                })
            }
        })
    }

    addFormData(newFormId = '', refetch = false, refetchCallback?: any, discard: boolean = false) {
        const formId = newFormId ? newFormId : this.props.match.params.formId;
        const appId = this.props.match.params.appId;
        const version = this.props.appVersion && this.props.appVersion.versionId;
        const currentVersion = this.props.appVersion && this.props.appVersion.currentVersion;
        const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
        const navigateTo = `/apps/list/${appId}/forms/list`

        Http.get(`/apps/${appId}/forms/${formId}/variables?versionId=${version}`).subscribe((res: any) => {
            this.props.autoCompleteVariables(res)

        }, (err) => {
            this.setState({ loading: false })
            redirectOnError(this.props.history, err.message, navigateTo, "View all forms", "formId");
            // this.props.pushToast && this.props.pushToast(
            //     { type: 'error', message: (err && err.message) ? err.message : "Autocomplete api getting failed" }
            // )
        })

        Http.get(`/apps/${appId}/forms/${formId}?versionId=${version}&branchId=${currentBranchId}`).subscribe((res: any) => {
            this.props.selectedForm(res)
            if (_.size(res) > 0) {
                this.props.updateFormVersion(res[0]?.isV2 ? "v2" : "v1");
                let formThemeObject = {}
                Http.get(`themes/${res[0].themeId}?appId=${appId}`).subscribe((themeRes: any) => {
                    const source = themeRes.source
                    formThemeObject = {
                        formPrimaryColor: source.primaryColour,
                        formPrimaryColorShadow: `${source.primaryColour}22`,
                        formFontColor: defaultTheme.formFontColor || source.primaryColour,
                        formBorderColor: defaultTheme.formBorderColor,
                        formBorderRadius: (source.border === 'None') ? '0px' :
                            (source.border === 'Soft') ? '8px' :
                                (source.border === 'Rounded') ? '16px' : '8px',
                        formFontSize: typeof (source.fontSize) === "string" ? source.fontSize + "px" : this.computeFontSize(source.fontsize),
                        formHeaderSize: this.computeHeaderSize(source.headerSize),
                        formSpacing: this.computeSpacing(source.spacing)
                    }
                    // Embed theme data onto JSON Form
                    this.props.addThemeInfo({
                        formId: formId,
                        theme: formThemeObject
                    })
                    this.setState({
                        theme: formThemeObject
                    })
                })
                res[0]['currentVersion'] = currentVersion
                this.HeaderData = HeaderData.sendMessage([...res])

                this.setState({ selectedFormData: res })
                const data = res[0];
                try {

                    this.setState({
                        resourceLock: data.resourceLock || {}
                    })
                    let lockData: any = {
                        resourceLock: data.resourceLock
                    }
                    if (refetch) {
                        lockData = {
                            ...lockData,
                            message: 'FORM_REFETCHED'
                        }
                    }
                    if (refetchCallback) {
                        lockData = {
                            ...lockData,
                            refetchedCallback: () => refetchCallback(data.resourceLock)
                        }
                    }
                    // send resource lock data to header
                    ResourceLock.sendMessage(lockData)
                    const formData = (data.source) ? decodeBase64(data.source) : '[]';
                    const parsedFormData = JSON.parse(formData);

                    // updating the form source to have the recent theme values
                    if (parsedFormData.length !== 0) {
                        parsedFormData[0].theme = formThemeObject
                    }

                    // Update form data only if refetch is requested with a source
                    if (refetch) {
                        if (data.source) {
                            this.props.saveOriginalFormData(formData)
                            this.props.addForms({
                                id: formId,
                                data: parsedFormData
                            })
                        }
                    } else {
                        // create new form does not have form source in db. so discard forms we create new tabs.
                        if (discard && !data.source) {
                            this.props.addForms({
                                id: formId,
                                data: parsedFormData
                            })
                            const id = "tab-0";
                            this.props.addTabs(formId, id, `Tab 1`);
                            const formJson = this.props.formcreation?.[formId]?.[0] ?? {};
                            fCardSelect.sendMessage({ id, json: { ...formJson, selectedSection: id } });
                        } else {
                            this.props.saveOriginalFormData(formData)
                            this.props.addForms({
                                id: formId,
                                data: parsedFormData
                            })
                        }
                    }
                    const selectedItemId = store.getState().contextMenu.selectedItemId;
                    // handle source new form does not exist form source from db.
                    if (discard && selectedItemId && data.source) {
                        const parentElement = getCardContainer(selectedItemId, formId);
                        if (parentElement) {
                            const elementIndex = selectedItemId.lastIndexOf("-");
                            const currentEle = Array.isArray(parentElement?.fields) ? parentElement?.fields[selectedItemId.slice(elementIndex + 1)] ?? null : null; 
                            const id = currentEle?.id;
                            if (id) {
                                const selectedSection = id.split("#").slice(0, 2).join("#");
                                fCardSelect.sendMessage({ id: id, json: { ...currentEle, selectedSection } });
                            }
                        } else if (selectedItemId?.split("#").length === 1) { 
                            // {selectedItemId} not have # the selected item is Tab(tab-0).
                            let tabJson = parsedFormData && parsedFormData.filter((x: {id : string}) => x.id === selectedItemId)[0];
                            const selectedSection = selectedItemId.split("#").slice(0, 2).join("#");
                            fCardSelect.sendMessage({ id: selectedItemId, json: { ...tabJson, selectedSection } });
                        }
                    }
                } catch (e) {
                    logger.error(e)
                    this.props.pushToast && this.props.pushToast(
                        { type: 'error', message: 'Source Parse Failed' }
                    )
                }
            } else {
                redirectOnError(this.props.history, 'no data', navigateTo, "View all forms", "formId");
                // this.props.pushToast && this.props.pushToast(
                //     { type: 'error', message: 'No data found' }
                // )
            }
            // if (!currentVersion) {
            //     const { appId, formId } = this.props.match.params;
            //     window.location.replace(`#/apps/list/${appId}/forms/list/${formId}/preview`)
            // }
            this.setState({ loading: false })
        }, (err) => {
            this.setState({ loading: false })
            // this.props.pushToast && this.props.pushToast(
            //     { type: 'error', message: (err && err.message) ? err.message : "Form Getting failed" }
            // )
        })
    }

    render() {
        const currentVersion = this.props.appVersion && this.props.appVersion.currentVersion;
        const isCheckedOut = this.state.resourceLock.userId === this.props.userId
        const canEdit = currentVersion && isCheckedOut && (this.props.orgPermissions.includes('forms.Edit') || this.props.appPermissions.includes('forms.Edit'))
        const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
        return (
            <React.Fragment>
                {(this.state.loading || this.state.widgetsLoading || this.state.assetsLoading) ? <div className={style.loadingSpinner + " row"}>
                    <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                </div> : <ThemeSwitcher theme={this.state.theme}>
                    {/* <DndProvider backend={HTML5Backend}> */}
                    <SplitPane className={style.split} paneStyle={{ width: '200px' }} minSize={200} maxSize={100}>
                        <Pane className={style.paneLeft + ' override-component-pane'} minSize="12.5%" initialSize="12.5%" maxSize="500px">
                            <Components data-test-id="components" canEdit={canEdit} selectedAppType={this.props.selectedAppType} />
                        </Pane>
                        <Pane className={style.pane} >
                            {this.props.assetEditMode ?
                                <AssetTab data-test-id="assets" canEdit={canEdit} />
                                :
                                <FormsTabs data-test-id="forms" canEdit={canEdit} />
                            }
                        </Pane>
                        <Pane className={style.paneRight + ' override-prop-pane'} initialSize="15%" minSize="20%" maxSize="500px">
                            <Properties data-test-id="properties" canEdit={canEdit} selectedFormData={this.state.selectedFormData} />
                        </Pane>
                    </SplitPane>
                    {/* </DndProvider> */}
                </ThemeSwitcher>}
            </React.Fragment>
        )
    }
}

const mapStatetoProps = (state: AppState, props: any) => {
    const params: any = props.match!.params;
    return {
        appVersion: state.apps.appVersion[params['appId']],
        currentTheme: state.org.selectedTheme,
        selectedAppType: state.apps && state.apps.selectedApp && state.apps.selectedApp.type,
        orgPermissions: state.org.orgPermissions,
        appPermissions: state.apps.selectedApp.permissions,
        currentBranch: state.apps.appBranch,
        selectedOrg: state.org.selectedOrg && state.org.selectedOrg.id,
        userId: state.user && state.user.data && state.user.data.user.id,
        assetEditMode: state.assets.assetEditMode,
        assetsList: state.assets.list,
        widgetId: state.widgetId,
        selectedOrgId: state.org.selectedOrg.id,
        selectedOrganisation: state.org.selectedOrg,
        loggedInUser:state.user.data.user,
        formcreation: state.formcreation
    }
}

export default withRouter(connect(mapStatetoProps, { addForms, pushToast, addThemeInfo, autoCompleteVariables, addWidget, addPackage, clearProduct, saveOriginalFormData, editAsset, loadAssets, selectedForm, removeForm, resetWidgetIds, updateFormVersion, addTabs })(FormCreate));
